import { useState, useEffect, Fragment } from "react";
import api from "../api";

// Factura visual SRI-like (igual a la factura de Linkotel/NETVOICE). Ver + Imprimir/PDF.
// Estilos inline (no depende del tema del panel) + CSS de impresión que aísla la hoja.

const $ = (v) => (v == null || v === "" || isNaN(Number(v)) ? "0.00" : Number(v).toFixed(2));
const val = (v) => (v == null || v === "" ? "" : String(v));
const fdate = (d) => (d ? String(d).slice(0, 10) : "");

const PRINT_CSS = `
@media print {
  body * { visibility: hidden !important; }
  #factura-print, #factura-print * { visibility: visible !important; }
  #factura-print { position: absolute !important; left: 0; top: 0; width: 100%; box-shadow: none !important; margin: 0 !important; }
  .factura-noprint { display: none !important; }
  @page { size: A4; margin: 12mm; }
}
`;

const B = "1px solid #222";            // borde
const CELL = { border: B, padding: "3px 6px", fontSize: 10, verticalAlign: "top" };
const TH = { ...CELL, background: "#f0f0f0", fontWeight: 700, textAlign: "center" };
const lbl = { fontSize: 9.5, fontWeight: 700 };
const txt = { fontSize: 10 };

function Barcode({ code }) {
  // Placeholder visual de código de barras (Code128 real = librería; acá barras determinísticas).
  const s = code || "0000000000000000000000000000000000000000000000000";
  const bars = [];
  for (let i = 0; i < s.length; i++) {
    const w = 1 + (s.charCodeAt(i) % 3);
    bars.push(<span key={i} style={{ display: "inline-block", width: w, height: 34, background: (i % 2 ? "#000" : "transparent") }} />);
  }
  return (
    <div style={{ textAlign: "center", marginTop: 4 }}>
      <div style={{ lineHeight: 0, whiteSpace: "nowrap", overflow: "hidden" }}>{bars}</div>
      <div style={{ fontSize: 8, marginTop: 2, wordBreak: "break-all" }}>{code || ""}</div>
    </div>
  );
}

function Body({ f }) {
  const e = f.emisor || {};
  const c = f.cliente || {};
  const fa = f.factura || {};
  const ia = f.info_adicional || {};
  const t = f.totales || {};
  const lineas = f.lineas || [];
  const formas = f.formas_pago || [];

  const infoRows = [
    ["Ciudad", ia.ciudad || c.ciudad || ""],
    ["Fecha Vencimiento", fdate(fa.fecha_vencimiento)],
    ["Contrato", val(ia.contrato)],
    ["Plan", val(ia.plan)],
    ["Periodo", val(ia.periodo || fa.periodo)],
    ["Teléfono", val(ia.telefono)],
  ];
  const totRows = [
    ["SUBTOTAL 15%", t.subtotal_15], ["SUBTOTAL 0%", t.subtotal_0],
    ["SUBTOTAL NO OBJETO DE IVA", t.subtotal_no_objeto], ["SUBTOTAL SIN IMPUESTOS", t.subtotal_sin_impuestos],
    ["TOTAL DESCUENTO", t.total_descuento], ["ICE", t.ice],
    [`IVA ${t.iva_rate != null ? Math.round(t.iva_rate) : 15}%`, t.iva], ["IRBPNR", t.irbpnr],
    ["PROPINA", t.propina], ["VALOR TOTAL", t.valor_total],
  ];

  return (
    <div style={{ fontFamily: "Arial, Helvetica, sans-serif", color: "#111" }}>
      {/* Cabecera: emisor (izq) + comprobante (der) */}
      <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
        <div style={{ flex: 1, border: B, padding: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <div style={{ fontWeight: 800, fontSize: 22, color: "#1a9e5f" }}>◉ Net<span style={{ color:"#111" }}>voice</span></div>
            <div style={{ fontSize: 8, color: "#666" }}>Powered by Telconet</div>
          </div>
          <div style={{ border: B, padding: 8, fontSize: 10 }}>
            <div style={{ fontWeight: 800, fontSize: 13 }}>{val(e.razon_social)}</div>
            {e.nombre_comercial ? <div style={{ fontWeight: 800, marginBottom: 4 }}>{e.nombre_comercial}</div> : null}
            <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "2px 8px" }}>
              <span style={lbl}>Dirección Matriz:</span><span style={txt}>{val(e.direccion_matriz)}</span>
              <span style={lbl}>Dirección Sucursal:</span><span style={txt}>{val(e.direccion_sucursal)}</span>
            </div>
            <div style={{ marginTop: 6, ...lbl }}>AGENTE DE RETENCIÓN No. {val(e.agente_retencion)}</div>
            <div style={{ marginTop: 6, display: "flex", justifyContent: "space-between", ...lbl }}>
              <span>OBLIGADO A LLEVAR CONTABILIDAD</span><span>{val(e.obligado_contabilidad) || "SI"}</span>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, border: B, padding: 8, fontSize: 10 }}>
          <div style={{ fontWeight: 800, fontSize: 13 }}>R.U.C.: {val(e.ruc)}</div>
          <div style={{ fontWeight: 800, fontSize: 18, marginTop: 4 }}>FACTURA</div>
          <div style={{ marginTop: 2 }}><span style={{ color: "#c00", fontWeight: 800 }}>No. </span><span style={{ fontWeight: 700 }}>{val(fa.numero) || "—"}</span></div>
          <div style={{ marginTop: 6, ...lbl }}>NÚMERO DE AUTORIZACIÓN</div>
          <div style={{ fontSize: 9, wordBreak: "break-all", minHeight: 12 }}>{val(fa.numero_autorizacion) || <em style={{ color:"#999" }}>PENDIENTE (autoriza el SRI)</em>}</div>
          <div style={{ marginTop: 6, ...lbl }}>FECHA Y HORA DE AUTORIZACIÓN: <span style={{ fontWeight: 400 }}>{val(fa.fecha_autorizacion)}</span></div>
          <div style={{ marginTop: 2, ...lbl }}>AMBIENTE: <span style={{ fontWeight: 400 }}>{val(fa.ambiente)}</span></div>
          <div style={{ ...lbl }}>EMISIÓN: <span style={{ fontWeight: 400 }}>NORMAL</span></div>
          <div style={{ marginTop: 4, ...lbl }}>CLAVE DE ACCESO</div>
          <Barcode code={fa.clave_acceso} />
        </div>
      </div>

      {/* Cliente */}
      <div style={{ border: B, padding: 8, marginBottom: 6, display: "grid", gridTemplateColumns: "auto 1fr auto 1fr", gap: "3px 8px", fontSize: 10 }}>
        <span style={lbl}>Razón Social / Nombres y Apellidos:</span><span style={txt}>{val(c.razon_social)}</span>
        <span style={lbl}>Fecha Emisión:</span><span style={txt}>{fdate(fa.fecha_emision)}</span>
        <span style={lbl}>RUC / CI:</span><span style={txt}>{val(c.ruc)}</span>
        <span style={lbl}>Guía Remisión:</span><span style={txt}></span>
        <span style={lbl}>Dirección:</span><span style={{ ...txt, gridColumn: "2 / 5" }}>{val(c.direccion)}</span>
      </div>

      {/* Detalle */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 6 }}>
        <thead><tr>
          <th style={TH}>Cod.<br/>Principal</th><th style={TH}>Cantidad</th><th style={TH}>Descripción</th>
          <th style={TH}>Detalle<br/>Adicional</th><th style={TH}>Precio Unitario</th><th style={TH}>Descuento</th><th style={TH}>Total</th>
        </tr></thead>
        <tbody>
          {lineas.length ? (() => {
            const groups = [];
            const idx = {};
            lineas.forEach((l) => {
              const k = l.line_did || "";
              if (idx[k] === undefined) { idx[k] = groups.length; groups.push({ did: k, rows: [] }); }
              groups[idx[k]].rows.push(l);
            });
            const out = [];
            groups.forEach((g, gi) => {
              if (g.did) out.push(
                <tr key={"h" + gi}><td colSpan={7} style={{ ...CELL, background: "#eef4ff", fontWeight: 700 }}>Línea: {g.did}</td></tr>
              );
              g.rows.forEach((l, i) => out.push(
                <tr key={gi + "-" + i}>
                  <td style={CELL}>{val(l.codigo)}</td>
                  <td style={{ ...CELL, textAlign: "right" }}>{Number(l.cantidad || 0).toFixed(2)}</td>
                  <td style={CELL}>{val(l.descripcion)}</td>
                  <td style={{ ...CELL, textAlign: "center" }}>{val(l.detalle_adicional)}</td>
                  <td style={{ ...CELL, textAlign: "right" }}>{Number(l.precio_unitario || 0).toFixed(6)}</td>
                  <td style={{ ...CELL, textAlign: "right" }}>{$(l.descuento)}</td>
                  <td style={{ ...CELL, textAlign: "right" }}>{$(l.total)}</td>
                </tr>
              ));
            });
            return out;
          })() : <tr><td style={{ ...CELL, textAlign: "center", color: "#999" }} colSpan={7}>Sin líneas (factura anterior a la generación con detalle)</td></tr>}
        </tbody>
      </table>

      {/* Formas de pago + info adicional (izq) · totales (der) */}
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <div style={{ flex: 1.3 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 6 }}>
            <thead><tr><th style={TH}>Formas de Pago</th><th style={{ ...TH, width: 90 }}>Valor</th></tr></thead>
            <tbody>{formas.map((p, i) => (
              <tr key={i}><td style={CELL}>{val(p.descripcion)}</td><td style={{ ...CELL, textAlign: "right" }}>{$(p.valor)}</td></tr>
            ))}</tbody>
          </table>
          <div style={{ border: B }}>
            <div style={{ ...TH, borderBottom: B }}>Información Adicional</div>
            <div style={{ padding: 6, display: "grid", gridTemplateColumns: "auto 1fr", gap: "2px 10px", fontSize: 10 }}>
              {infoRows.map(([k, v]) => (<Fragment key={k}><span style={lbl}>{k}:</span><span style={txt}>{v}</span></Fragment>))}
              <span style={{ ...lbl, fontWeight: 800 }}>Consumo del Mes:</span><span style={{ ...txt, fontWeight: 800 }}>{$(ia.consumo_mes)}</span>
              <span style={{ ...lbl, fontWeight: 800 }}>Deuda Pendiente:</span><span style={{ ...txt, fontWeight: 800 }}>{$(ia.deuda_pendiente)}</span>
              <span style={{ ...lbl, fontWeight: 800 }}>Saldo a Favor:</span><span style={{ ...txt, fontWeight: 800 }}>{$(ia.saldo_favor)}</span>
              <span style={{ ...lbl, fontWeight: 800 }}>Total a Pagar:</span><span style={{ ...txt, fontWeight: 800 }}>{$(ia.total_a_pagar)}</span>
              <span style={lbl}>Observaciones:</span><span style={txt}>{val(ia.observaciones)}</span>
            </div>
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>{totRows.map(([k, v], i) => (
              <tr key={i} style={k === "VALOR TOTAL" ? { fontWeight: 800 } : null}>
                <td style={{ ...CELL, background: "#f0f0f0", fontWeight: 700 }}>{k}</td>
                <td style={{ ...CELL, textAlign: "right" }}>{$(v)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>

      {/* Footer legal */}
      {e.footer_legal ? <div style={{ marginTop: 10, fontSize: 7.5, textAlign: "center", color: "#333", lineHeight: 1.5 }}>{e.footer_legal}</div> : null}
    </div>
  );
}

export default function FacturaVista({ invoiceId, onClose }) {
  const [f, setF] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let ok = true;
    api.get("/billing/invoices/" + invoiceId + "/factura")
      .then((r) => { if (ok) setF(r.data); })
      .catch((e) => { if (ok) setErr(e?.response?.data?.detail || "Error al cargar la factura"); });
    return () => { ok = false; };
  }, [invoiceId]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.6)", zIndex: 2000,
                  display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", padding: 20 }}>
      <style>{PRINT_CSS}</style>
      <div className="factura-noprint" style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button className="nv-btn nv-btn-primary" onClick={() => window.print()} disabled={!f}>🖨 Imprimir / PDF</button>
        <button className="nv-btn nv-btn-secondary" onClick={onClose}>Cerrar</button>
      </div>
      <div id="factura-print" style={{ background: "#fff", width: 820, maxWidth: "100%", padding: 24,
                                       boxShadow: "0 8px 40px rgba(0,0,0,.4)" }}>
        {err ? <div style={{ color: "#c00", padding: 20 }}>{err}</div>
             : !f ? <div style={{ padding: 40, textAlign: "center", color: "#666" }}>Cargando factura…</div>
             : <Body f={f} />}
      </div>
    </div>
  );
}
